import { ReferenceDot as _ } from "../cartesian/ReferenceDot.js";
import { ReferenceLine as I } from "../cartesian/ReferenceLine.js";
import { ReferenceArea as R } from "../cartesian/ReferenceArea.js";
import { ifOverflowMatches as g } from "./IfOverflowMatches.js";
import { findAllByType as c } from "./ReactUtils.js";
import { isNumber as p } from "./DataUtils.js";
function M(r) {
  return E(r) || j(r) || x(r) || w();
}
function w() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function x(r, e) {
  if (r) {
    if (typeof r == "string") return y(r, e);
    var n = Object.prototype.toString.call(r).slice(8, -1);
    if (n === "Object" && r.constructor && (n = r.constructor.name), n === "Map" || n === "Set") return Array.from(r);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return y(r, e);
  }
}
function j(r) {
  if (typeof Symbol < "u" && r[Symbol.iterator] != null || r["@@iterator"] != null) return Array.from(r);
}
function E(r) {
  if (Array.isArray(r)) return y(r);
}
function y(r, e) {
  (e == null || e > r.length) && (e = r.length);
  for (var n = 0, f = new Array(e); n < e; n++) f[n] = r[n];
  return f;
}
var L = function(e, n, f, s, u) {
  var D = c(e, I), S = c(e, _), v = [].concat(M(D), M(S)), d = c(e, R), b = "".concat(s, "Id"), m = s[0], a = n;
  if (v.length && (a = v.reduce(function(o, t) {
    if (t.props[b] === f && g(t.props, "extendDomain") && p(t.props[m])) {
      var i = t.props[m];
      return [Math.min(o[0], i), Math.max(o[1], i)];
    }
    return o;
  }, a)), d.length) {
    var h = "".concat(m, "1"), A = "".concat(m, "2");
    a = d.reduce(function(o, t) {
      if (t.props[b] === f && g(t.props, "extendDomain") && p(t.props[h]) && p(t.props[A])) {
        var i = t.props[h], l = t.props[A];
        return [Math.min(o[0], i, l), Math.max(o[1], i, l)];
      }
      return o;
    }, a);
  }
  return u && u.length && (a = u.reduce(function(o, t) {
    return p(t) ? [Math.min(o[0], t), Math.max(o[1], t)] : o;
  }, a)), a;
};
export {
  L as detectReferenceElementsDomain
};
